import { Crown } from "lucide-react";

export const VipBadge = ({ className = "" }) => (
  <span data-testid="vip-badge"
    className={`inline-flex items-center gap-1 text-[10px] font-cinzel uppercase tracking-widest px-2 py-0.5 rounded-sm border border-amber-500/60 bg-amber-500/10 text-amber-300 ${className}`}>
    <Crown size={11} className="text-amber-400 fill-amber-500/40" /> VIP
  </span>
);
